import { useMutation } from "@tanstack/react-query";
import { MemberService } from "@/generated/services/MemberService";
export function useUpdateMember() {
  return useMutation({
    mutationFn: async (payload: {
      memberId: string;
      holderId?: string;
      waon_inquiry_number?: string;
      encrypted_ref?: string;
    }) => {
      const { memberId, waon_inquiry_number } = payload;

      const response = MemberService.patchMembers(Number(memberId), {
        inquiry_number_hash: waon_inquiry_number,
      });
      return response;
    },
  });
}
